import React, { useEffect } from 'react';
import AcademyApp from './components/academy/AcademyApp';
import { defaultConfig, applyTheme } from './config/academyConfig';
import './App.css';

function App() {
  useEffect(() => {
    // Apply theme on mount
    applyTheme(defaultConfig);
  }, []);

  return <AcademyApp config={defaultConfig} />;
}

export default App;
